import script from "./SwitchProfile.vue?vue&type=script&setup=true&lang=js"
export * from "./SwitchProfile.vue?vue&type=script&setup=true&lang=js"

import "./SwitchProfile.vue?vue&type=style&index=0&id=00408c8c&lang=scss"

const __exports__ = script;

export default __exports__